import { render, staticRenderFns } from "./NavSkeleton.vue?vue&type=template&id=2eb030d1&scoped=true"
var script = {}
import style0 from "../Preview.scss?vue&type=style&index=0&id=2eb030d1&prod&lang=scss&scoped=true&external"
import style1 from "./NavSkeleton.vue?vue&type=style&index=1&id=2eb030d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb030d1",
  null
  
)

export default component.exports